import React from 'react'
import { Field } from 'redux-form'
import { renderField } from "./FormValidation";

const PlateField = ({ name, label, validate, placeholder, icon, mask }) => {
    return (
        <Field
            name={name}
            type='tel'
            component={renderField}
            label={label}
            validate={validate}
            placeholder={placeholder}
            icon={icon}
            mask={'***-****'}
        />
    )
}
export default PlateField